import React from 'react';
import { usePdfGeneration } from './PdfGenerationContext';
import { useToast } from './ToastContext';

const PDF_TOAST_ID = 'pdf_generation_toast';

export function PdfGenerationOverlay() {
  const { isPdfGenerating } = usePdfGeneration();
  const { showToast, dismissToast } = useToast();

  React.useEffect(() => {
    if (isPdfGenerating) {
      showToast({
        id: PDF_TOAST_ID,
        type: 'info',
        message: 'PDF is being generated…',
        persistent: true,
        spinner: true,
      });
      return;
    }

    dismissToast(PDF_TOAST_ID);
  }, [dismissToast, isPdfGenerating, showToast]);

  return null;
}
